import { IconProps } from '@models/icons';

function SearchLine({ size = 30, color = '#6E6864', ...rest }:IconProps) {
  return (
        <svg width={size} height={size} viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...rest} >
            <path
                d="M20.2223 17.106L24.1916 21.0753C24.9142 21.7978 24.9142 22.9693 24.1916 23.6919V23.6919C23.4691 24.4145 22.2975 24.4145 21.575 23.6919L17.6208 19.7377"
                stroke={color} strokeWidth="1.95124"/>
            <path
                d="M13.6582 5.97559C17.6251 5.97559 20.8407 9.19135 20.8408 13.1582C20.8408 17.1252 17.6252 20.3408 13.6582 20.3408C9.69135 20.3407 6.47559 17.1251 6.47559 13.1582C6.47571 9.19143 9.69142 5.97571 13.6582 5.97559Z"
                stroke={color} strokeWidth="1.95124"/>
        </svg>
  );
}

export default SearchLine;
